<template>
  <div class="flex w-full items-baseline justify-center gap-1">
    <span class="text-base-content/80 text-base italic">
      Không tìm thấy bản ghi nào! <slot name="action"></slot>
    </span>
  </div>
</template>
